import axios from "axios";

export const logginIn = async({
    username,
    password,
    setError,
    setLoader,
    setPassword,
    user,
    global,
    login = true
}) => {
    setError(null)
    setLoader(true)
    let url = global.domain+`v3-api/v3/login.json`;
    let res = await axios.post(url, {
        username,
        password
    }).catch(function (error) {
        setError(error.message)
        console.error(error.message)
        setLoader(false)
    });
    if(!res?.data){
        setPassword('')
        setError('Error con el usuario y contrasena')
        setLoader(false)
        return;
    }

    var metadata = {
        user: res.data
    }
    
    localStorage.setItem('user', JSON.stringify(res.data));
    const token = (res?.data?.franchise?.paymentMethods ?? []).find(payment => payment.actionname === 'quentli')?._matchingData?.FranchisePaymentmethods?.value ?? undefined;
    localStorage.setItem('QuentliToken', token);
    user.setUser(res.data);

    setLoader(false)
}